/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./videoViewer.vue?vue&type=template&id=1c5f50a8&scoped=true&"
import script from "./videoViewer.vue?vue&type=script&lang=js&"
export * from "./videoViewer.vue?vue&type=script&lang=js&"
import style0 from "./videoViewer.vue?vue&type=style&index=0&id=1c5f50a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f50a8",
  null
  
)

export default component.exports